import React from 'react'
import PropTypes from 'prop-types'
import { LayoutPageWrapper } from 'goustouicomponents/dist/LayoutPageWrapper'
import { Heading } from 'goustouicomponents/dist/Heading'
import css from './HeroMessage.module.css'

const HeroMessage = ({ message }) => (
  <section className={css.wrapper}>
    <LayoutPageWrapper>
      <Heading type="h1" size="fontStyleXL">
        {message}
      </Heading>
    </LayoutPageWrapper>
  </section>
)

HeroMessage.propTypes = {
  message: PropTypes.string.isRequired,
}

export { HeroMessage }
